clipboard = {
	visible: false,

	init() {
		$('.js-clipboard:not(.ok)').on('click', this.copy.bind(this));
	},

	//Скопировать текст
	copy(event) {
		var
			$element = $(event.currentTarget),
			$temp = $('<input>'),
			text = $element.attr('data-clipboard') ?? false,
			hint = $element.attr('data-clipboard-hint') ?? false;

		if (!text) text = $element.text();

		text = text.trim();

		$('body').append($temp);
		$temp.val(text).select();

		document.execCommand('copy');

		$temp.remove();

		this.showHint(hint, event.pageX + 10, event.pageY + 10);
	},

	//Показать подсказку
	showHint(hint, x, y) {
		var
			$clipboard = $('#clipboard'),
			oldHint = $clipboard.text(),
			/*x = $parent.offset().left + $parent.width() / 2 - $clipboard.width() / 2,
			y = $parent.offset().top + $parent.height() / 2 - $clipboard.height() / 2;*/
			self = this;

		if (self.visible) return false;

		if (hint) $clipboard.text(hint);

		$clipboard.css({
			left: x + 'px',
			top: y + 'px'
		}).show();

		self.visible = true;

		setTimeout(function() {
			$clipboard.fadeOut(200, function() {
				$clipboard.text(oldHint);
				self.visible = false;
			});
		}, 5000);
	}
}



$(document).init(function() {
	clipboard.init();
});